module.exports = __webpack_public_path__ + "static/img/e76fc5d.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/livepoint/tittle.png
// module id = 617
// module chunks = 2